export default __webpack_public_path__ + "imgs/5210d897.png";